<template>
  <PageLayout class="accident-page">
     <div class="row pt-4">
       <div class="col-12">
          <AccidentResults />
       </div>
     </div>
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import AccidentResults from '../../views/accident/results.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { PageLayout, AccidentResults },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>
<style lang="scss" scoped>
::v-deep button {
  text-align: center;
}

::v-deep input {
  border: 1px solid #dde2e5 !important;
  border-radius: 3px !important;

  &:hover {
    border-color: #ffad3d !important;
  }
}

::v-deep .multiselect__input {
  border: none !important;
}
</style>
